(function (){
    'use strict';

    angular
        .module('travelExpenses', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'countryDirective',
            'daterangepicker',
            'fuelux.wizard',
            'mgo-angular-wizard',
            'easypiechart',
            'ngAnimate',
            'angularMoment',
            'ui.bootstrap.datetimepicker',
            'ui.dateTimeInput',
            'camera',
            'ui.utils.masks',
            '720kb.tooltips',
            'angular-popover',
            'ngclipboard',
            'toastr'
        ]);
})();